import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useUpdateOrchestratorTaskStatusMutation } from '@domains/orchestrator-pricing-committee';
import { getEditorPayloadTask } from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { useSelectedWorkflowStep } from '@domains/orchestrator-pricing-committee/hooks/useSelectedWorkflowStep';

export const EditorTaskSubmitButton = () => {
  const { step } = useSelectedWorkflowStep();
  const payload = useSelector(getEditorPayloadTask);

  const [updateStatus, { isLoading, isSuccess, isError }] =
    useUpdateOrchestratorTaskStatusMutation();

  const handleClick = () => {
    if (!step) return;
    updateStatus(payload as any);
  };

  if (isError) toast.error('Error actualizando la tarea');
  if (isSuccess) toast.success('Tarea actualizada correctamente');

  if (!step) return null;

  return (
    <Button
      className="btn-habi"
      onClick={handleClick}
      disabled={isLoading}
      data-testid="editor-task-submit-button"
    >
      Enviar tarea
    </Button>
  );
};
